import { Route, Routes } from 'react-router-dom';
import { WheelOfFortune } from '../../games/WheelOfFortune/WheelOfFortune';
import { GamesList } from './GamesList';

export enum GameContext {
    WheelOfFortune = 'wheel-of-fortune',
}

export const GameRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<GamesList />} />
            <Route path={`/${GameContext.WheelOfFortune}`} element={<WheelOfFortune />} />
        </Routes>
    );
};